<template lang="pug">
.Display
  .Display__item(v-for="url in list")
    iframe.Display__iframe(:src="url")
</template>

<script>
import IfContainer from '@/components/page-components/IfContainer.vue';

export default {
  name: 'Display',
  components: {
    IfContainer,
  },
  data() {
    return {
      list: [
        'https://git.page/ziv/youtube?tags=ypcloud&auto=1',
        'https://git.page/ziv/youtube?tags=tz&auto=1',
        'https://git.page/ziv/rss?tags=ypcloud',
        'https://git.page/ziv/rss?tags=tz',
      ],
    };
  },
};
</script>

<style lang="sass">
.Display
  +ab_start
  +size(100%, 100%)
  +flex(flex-start, stretch)
  flex-wrap: wrap
  &__item
    +size(49.5%, 49%)
    +flex
    box-sizing: border-box
    margin: .25%
    box-shadow: 0px 0px 2px 2px fade-out($secondary, .7)
  &__iframe
    width: 100%
    height: 100%
    &::-webkit-scrollbar
      display: none

::-webkit-scrollbar
  display: none
</style>
